import { FocusTarget } from 'focus-trap';
import FocusTrap from 'focus-trap-react';
import { observer } from 'mobx-react';
import { forwardRef } from 'react';

interface ModalFocusTrapProps {
  children: React.ReactNode;
  fallbackFocus?: FocusTarget;
}

const Children = forwardRef<HTMLDivElement, ModalFocusTrapProps>(({ children }, ref) => (
  // can't use a fragment here because focus-trap-react requires a single child element
  // and fragment doesn't forward refs properly
  <div ref={ref}>{children}</div>
));

function ModalFocusTrap({ children, fallbackFocus }: ModalFocusTrapProps) {
  return (
    <FocusTrap
      focusTrapOptions={{
        escapeDeactivates: false,
        initialFocus: fallbackFocus || '#modal-container',
        fallbackFocus: fallbackFocus || '#modal-container',
        delayInitialFocus: false,
        allowOutsideClick: true,
      }}
    >
      <Children children={children} />
    </FocusTrap>
  );
}

export default observer(ModalFocusTrap);
